module.exports = __webpack_public_path__ + "static/CleanAir-Desktop-Header-1920x340-Curve-News-2x-83bd26f8be4c58a97bac05ce8921fcf5.png";